import { render, staticRenderFns } from "./vwBillsToReceive.vue?vue&type=template&id=5f5828d0&"
import script from "./vwBillsToReceive.vue?vue&type=script&lang=js&"
export * from "./vwBillsToReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports